import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import {
  Box,
  Tooltip,
  CircularProgress,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Popover,
} from "@mui/material";
import CustomTypography from "../../globalStyles/fonts";
import DeleteConfirmationModal from "../deleteConfirmationModal";
import { isMobile } from "../../globalStyles/mobile";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ZoneDetailsModal from "../zoneViewDetailsModal";
import DeleteIcon from "../../globalStyles/icons/deleteIcon";
import EditIcon from "../../globalStyles/icons/editIcon";
import ViewIcon from "../../globalStyles/icons/vieewIcon";
import { originZoneService } from "../../utils/services/originZoneService";
import { useTheme } from "@mui/styles";
import { toast } from "react-toastify";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--table-header-bg)",
    border: "1px solid var(--border-color)",
    padding: "4px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: "6px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "var(--row-bg-odd)",
    border: "1px solid var(--border-color)",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "var(--row-bg-even)",
    border: "1px solid var(--border-color)",
  },
  "&:lastChild td, &:lastChild th": {
    border: 0,
  },
}));

const ZoneTableCell = ({
  zone,
  handleViewClick,
  handleEditClick,
  handleDeleteClick,
  handleClientAssignClick,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const handleActionClick = (action) => {
    handlePopoverClose();
    switch (action) {
      case "view":
        handleViewClick(zone);
        break;
      case "edit":
        handleEditClick(zone);
        break;
      case "delete":
        handleDeleteClick(zone);
        break;
      case "assign":
        handleClientAssignClick(zone);
        break;
      default:
        break;
    }
  };

  return (
    <Box>
      <IconButton
        aria-label="more actions"
        onClick={handlePopoverOpen}
        sx={{
          color: open ? "primary.main" : "inherit",
        }}
      >
        <MoreVertIcon />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", padding: "10px" }}>
          <Button
            onClick={() => handleActionClick("edit")}
            style={{ textTransform: "none" }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              width="100%"
              gap={1}
            >
              <EditIcon />
              <Typography
                fontFamily={"poppins"}
                fontSize={"16px"}
                color={"var(--text-tertiary)"}
                fontWeight={500}
              >
                Edit
              </Typography>
            </Box>
          </Button>
          <Button
            onClick={() => handleActionClick("view")}
            style={{ textTransform: "none" }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              width="100%"
              gap={1}
            >
              <ViewIcon />
              <Typography
                fontFamily={"poppins"}
                fontSize={"16px"}
                color={"var(--text-tertiary)"}
                fontWeight={500}
              >
                View
              </Typography>
            </Box>
          </Button>

          <Button
            onClick={() => handleActionClick("delete")}
            style={{ textTransform: "none" }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              width="100%"
              gap={1}
            >
              <DeleteIcon />
              <Typography
                fontFamily={"poppins"}
                fontSize={"16px"}
                color={"var(--text-tertiary)"}
                fontWeight={500}
              >
                Delete
              </Typography>
            </Box>
          </Button>
          <Button
            onClick={() => handleActionClick("assign")}
            style={{ textTransform: "none" }}
          >
            {/* <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              width="100%"
              gap={1}
            >
              <ClientAssignIcon />
              <Typography
                fontFamily={"poppins"}
                fontSize={"16px"}
                color={"var(--text-tertiary)"}
                fontWeight={500}
              >
                Client Assign
              </Typography>
            </Box> */}
          </Button>
        </Box>
      </Popover>
    </Box>
  );
};
const ZoneList = ({
  data,
  onEditData,
  onDeleteData,
  viewMode,
  selectedZone,
  setSelectedZone,
  currentPage,
  itemsPerPage,
}) => {
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [selectedZoneData, setSelectedZoneData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const startIndex = currentPage * itemsPerPage;
  const theme = useTheme();
  const defaultColor = "#D13438";
  const primary_color = theme.palette?.primary?.main || defaultColor;

  const handleDeleteClick = (port) => {
    setSelectedZone(port);
    setOpenConfirmation(true);
  };

  const confirmDelete = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await originZoneService.delete(selectedZone._id);
      onDeleteData && onDeleteData();
      toast.success("Zone deleted successfully");
      setOpenConfirmation(false);
    } catch (error) {
      console.error("Delete failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewClick = (zone) => {
    setSelectedZone(zone);
    setOpenViewModal(true);
  };

  const handleClientAssignClick = (x) => {
    setSelectedZone(x);
    setModalOpen(true);
  };
  useEffect(() => {
    setSelectedZoneData(
      data?.map((zone) => ({
        ...zone,
        action: (
          <ZoneTableCell
            zone={zone}
            handleViewClick={handleViewClick}
            handleEditClick={onEditData}
            handleDeleteClick={handleDeleteClick}
            handleClientAssignClick={handleClientAssignClick}
          />
        ),
      }))
    );
  }, [data]);
  const renderGridView = () => (
    <Grid
      sx={{
        marginTop: "1px",
        maxHeight: "100%",
        paddingBottom: 5,
        overflow: "auto",
      }}
      container
      spacing={2}
    >
      {selectedZoneData?.map((item, index) => (
        <Grid sx={{ paddingBottom: 1 }} item xs={12} sm={6} md={4} key={index}>
          <Card
            sx={{
              boxShadow: 3,
              cursor: "pointer",
              width: "100%",
              height: "100%",
              position: "relative",
              borderRadius: "6px",
              border: "1px solid #D0D5DD",
            }}
          >
            <CardContent>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  fontWeight="500"
                  sx={{ textAlign: "start" }}
                  fontFamily="Poppins"
                  color="var(--text-tertiary)"
                >
                  {startIndex + index + 1}
                </Typography>
                <div
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                  }}
                >
                  {item?.action}
                </div>
              </div>
              <Grid container spacing={1} mt={2}>
                <Grid item xs={5} display="flex" alignItems="center">
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily="Poppins"
                    color="var(--text-tertiary)"
                  >
                    Name
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Tooltip title={item?.name} arrow>
                    <Typography
                      noWrap
                      sx={{ textAlign: "start" }}
                      fontWeight="500"
                      fontFamily={"poppins"}
                      color={"var(--text-tertiary)"}
                    >
                      : {item?.name}
                    </Typography>
                  </Tooltip>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    Code
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Tooltip title={item?.zone_number} arrow>
                    <Typography
                      noWrap
                      sx={{ textAlign: "start" }}
                      fontWeight="500"
                      fontFamily={"poppins"}
                      color={"var(--text-tertiary)"}
                    >
                      : {item?.code}
                    </Typography>
                  </Tooltip>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    Zip
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Tooltip title={item?.zone_number} arrow>
                    <Typography
                      noWrap
                      sx={{ textAlign: "start" }}
                      fontWeight="500"
                      fontFamily={"poppins"}
                      color={"var(--text-tertiary)"}
                    >
                      : {item?.zip}
                    </Typography>
                  </Tooltip>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );

  // const MobileCardView = ({ data }) => {
  //   return (
  //     <Box sx={{ width: "100%", padding: 0.5 }}>
  //       {data?.map((zone, index) => (
  //         <Card
  //           key={index}
  //           sx={{
  //             marginBottom: 2,
  //             backgroundColor: "#ffffff",
  //             borderRadius: 4,
  //             position: "relative",
  //           }}
  //         >
  //           <CardContent>
  //             <Box position="absolute" top={2} right={5}>
  //               {zone?.action}
  //             </Box>
  //             <Box display="flex" flexDirection="column" mt={2}>
  //               <Grid container spacing={2}>
  //                 <Grid item xs={6}>
  //                   <Typography
  //                     fontSize={14}
  //                     fontFamily="poppins"
  //                     color="#000000"
  //                     fontWeight={600}
  //                     textAlign="left"
  //                   >
  //                     Zone Name
  //                   </Typography>
  //                 </Grid>
  //                 <Grid item xs={6}>
  //                   <Typography
  //                     fontSize={14}
  //                     fontFamily="poppins"
  //                     color="#606060"
  //                     fontWeight={500}
  //                     textAlign="left"
  //                     noWrap
  //                     sx={{
  //                       overflow: "hidden",
  //                       textOverflow: "ellipsis",
  //                       whiteSpace: "nowrap",
  //                       maxWidth: "100%",
  //                     }}
  //                   >
  //                     : {zone?.name}
  //                   </Typography>
  //                 </Grid>
  //                 <Grid item xs={6}>
  //                   <Typography
  //                     fontSize={14}
  //                     fontFamily="poppins"
  //                     color="#000000"
  //                     fontWeight={600}
  //                     textAlign="left"
  //                   >
  //                     Zone Number
  //                   </Typography>
  //                 </Grid>
  //                 <Grid item xs={6}>
  //                   <Typography
  //                     fontSize={14}
  //                     fontFamily="poppins"
  //                     color="#606060"
  //                     fontWeight={500}
  //                     textAlign="left"
  //                     noWrap
  //                     sx={{
  //                       overflow: "hidden",
  //                       textOverflow: "ellipsis",
  //                       whiteSpace: "nowrap",
  //                       maxWidth: "100%",
  //                     }}
  //                   >
  //                     : {zone?.zone_number}
  //                   </Typography>
  //                 </Grid>
  //               </Grid>
  //             </Box>
  //           </CardContent>
  //         </Card>
  //       ))}
  //     </Box>
  //   );
  // };

  const renderListView = () => (
    <div
      style={{
        width: "100%",
        overflow: isMobile() ? "auto" : "hidden",
        // paddingBottom: 100,
        paddingBottom: 20,
        marginTop: 5,
      }}
    >
      {isMobile() ? (
        renderGridView()
      ) : (
        <TableContainer
          //  className="custom-container"
          sx={{
            // maxHeight: "70vh",
            overflowY: "auto",
            paddingInline: 0.4,
            maxHeight: "100%",
          }}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            sx={{
              border: "1px solid var(--border-color)",
            }}
          >
            <TableHead>
              <StyledTableRow>
                <StyledTableCell>
                  <Typography
                    fontSize="14px"
                    color="var(--text-tertiary)"
                    fontWeight={500}
                    fontFamily={"poppins"}
                  >
                    SL NO
                  </Typography>
                </StyledTableCell>
                <StyledTableCell>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                      //marginLeft: 20,
                    }}
                  >
                    {/* {filterData.columns.find((x) => x.key === "name")?.sort ===
                    1 ? (
                      <Icon>
                        <UpIcon color="disabled" />
                      </Icon>
                    ) : filterData.columns.find((x) => x.key === "name")
                        ?.sort === -1 ? (
                      <Icon>
                        <DownIcon color="disabled" />
                      </Icon>
                    ) : null} */}
                    <Typography
                      fontSize="14px"
                      title={true}
                      color="var(--text-tertiary)"
                      fontWeight={500}
                      fontFamily={"poppins"}
                    >
                      NAME
                    </Typography>
                    {/* <IconButton
                      aria-label="filter"
                      size="small"
                      //sonClick={(event) => handleOpenFilter(event, "name")}
                    >
                      <SortingIcon fill={primary_color} />
                    </IconButton> */}
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                    }}
                  >
                    <CustomTypography
                      fontSize="14px"
                      title={true}
                      color="var(--text-tertiary)"
                      fontWeight={500}
                    >
                      CODE
                    </CustomTypography>
                  </div>
                </StyledTableCell>
                <StyledTableCell>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <CustomTypography
                      fontSize="14px"
                      title={true}
                      color="var(--text-tertiary)"
                      fontWeight={500}
                    >
                      ZIP
                    </CustomTypography>
                  </div>
                </StyledTableCell>

                <StyledTableCell>
                  <CustomTypography
                    fontSize="14px"
                    title={true}
                    color="var(--text-tertiary)"
                    fontWeight={500}
                  ></CustomTypography>
                </StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {selectedZoneData?.map((zone, index) => (
                <StyledTableRow key={index}>
                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="var(--text-secondary)"
                      fontWeight={400}
                      fontFamily={"Poppins"}
                    >
                      {startIndex + index + 1}
                    </Typography>
                  </StyledTableCell>
                  <Tooltip title={zone?.name}>
                    <StyledTableCell>
                      <Typography
                        style={{
                          // marginLeft: 22,
                          maxWidth: 100,
                          whiteSpace: "nowrap", // Ensure single line
                          overflow: "hidden", // Prevent text overflow
                          textOverflow: "ellipsis", // Show ellipsis for overflow text
                        }}
                        fontSize="12px"
                        color="var(--text-secondary)"
                        fontWeight={400}
                        fontFamily={"Poppins"}
                        title={zone?.name} // Add a title attribute to show full text on hover
                      >
                        {zone?.name}
                      </Typography>
                    </StyledTableCell>
                  </Tooltip>

                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="var(--text-secondary)"
                      fontWeight={400}
                      fontFamily={"poppins"}
                    >
                      {zone?.code}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell style={{ textAlign: "center" }}>
                    <Typography
                      fontSize="12px"
                      color="var(--text-secondary)"
                      fontWeight={400}
                      fontFamily={"poppins"}
                    >
                      {zone?.zip}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell sx={{ width: "3%", textAlign: "center" }}>
                    {zone?.action}
                  </StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );

  return (
    <div sx={{ minWidth: "100%" }}>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            color: "white",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      ) : (
        <div
          style={{
            overflowY: "scroll",
            display: "flex",
            maxHeight: isMobile() ? "60vh" : `calc(100vh - 250px)`,
            width: "100%",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::WebkitScrollbar": { width: 0 },
          }}
        >
          {viewMode === "grid" ? renderGridView() : renderListView()}
        </div>
      )}

      <DeleteConfirmationModal
        DeleteConfirmationModal
        title={`Are you sure you want to delete ${selectedZone?.name} ?`}
        open={openConfirmation}
        handleClose={() => setOpenConfirmation(false)}
        handleDelete={(e) => {
          confirmDelete(e);
        }}
      />
      {/* <AssignClient
        selectedData={selectedZone}
        mapKey="zone"
        open={modalOpen}
        onClose={() => setModalOpen(false)}
      /> */}
      <ZoneDetailsModal
        zone={selectedZone}
        open={openViewModal}
        onClose={() => setOpenViewModal(false)}
      />
    </div>
  );
};

export default ZoneList;
